import React, { useState, useCallback, useRef } from "react";
// import { RiDownloadCloudLine } from "react-icons/ri";
// import { BsFolderSymlinkFill } from "react-icons/bs";
// import { AiOutlineSave } from "react-icons/ai";
import { FaDownload } from "react-icons/fa";
import $ from "jquery";

let newLists = [];

export default function Download({ buyingList, setBuyingLists }) {
  $(".custom-file-input").on("change", function () {
    let fileName = $(this).val().split("\\").pop();
    $(this).next(".custom-file-label").addClass("selected").html(fileName);
  });
  const [fileName, setfileName] = useState("");
  const fileInput = useRef();
  const handleChange = (e) => {
    document.getElementById("uplaodSuccess").classList.add("d-none");
    document.getElementById("uplaodFailed").classList.add("d-none");
    newLists = [];
    const fileReader = new FileReader();
    fileReader.readAsText(e.target.files[0], "UTF-8");
    fileReader.onload = (e) => {
      const lists = JSON.parse(e.target.result);
      lists.forEach((list) => {
        newLists.push(list);
      });
    };
  };

  const resetInputs = () => {
    setfileName("");
    fileInput.current.value = "";
    document.getElementById("uplaodFileInput").innerHTML = "اختر الملف";
    document.getElementById("uplaodSuccess").classList.add("d-none");
    document.getElementById("uplaodFailed").classList.add("d-none");
  };

  const updateLists = useCallback(
    (e) => {
      e.preventDefault();
      if (fileInput.current.value === "" || newLists.length === 0) {
        document.getElementById("uplaodFailed").classList.remove("d-none");
      } else {
        document.getElementById("uplaodSuccess").classList.remove("d-none");
        fileInput.current.value = "";
        document.getElementById("uplaodFileInput").innerHTML = "اختر ملف";
        setBuyingLists(newLists);
      }
    },
    [setBuyingLists]
  );

  return (
    <div>
      <span data-toggle="modal" data-target="#downloadModal">
        <button
          className="btn btn-sm btn-outline-light"
          data-toggle="tooltip"
          data-placement="bottom"
          title="حفظ/رفع البيانات"
          onClick={() => {
            resetInputs();
            $("button").tooltip("hide");
          }}
        >
          <FaDownload size="1.2em" />
        </button>
      </span>
      <div
        className="modal fade"
        id="downloadModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-dark" id="exampleModalLabel">
                التحكم في البيانات
              </h5>
              <button
                type="button"
                className="close ml-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              className="alert alert-success show fade mx-2 mt-2 mb-0 p-2 d-none text-center"
              role="alert"
              id="uplaodSuccess"
            >
              <p className="p-0 m-0">تم رفع البيانات بنجاح</p>
            </div>
            <div
              className="alert alert-danger show fade mx-2 mt-2 mb-0 p-2 d-none text-center"
              role="alert"
              id="uplaodFailed"
            >
              <p className="p-0 m-0">ملف غير صالح</p>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-row">
                  <label htmlFor="inputEmail4" className="text-dark">
                    حفظ البيانات
                  </label>
                  <div className="form-group col-md-12 text-right mb-0">
                    <input
                      type="text"
                      value={fileName}
                      onChange={(e) => setfileName(e.target.value)}
                      className="form-control"
                      placeholder="اسم الملف"
                    ></input>
                    <small className="form-text text-muted">
                      ادخل اسم الملف او انقر حفظ وسيتم انشاء اسم تلقائي للملف
                    </small>
                    <a
                      href={`data:text/json;charset=utf-8,${encodeURIComponent(
                        JSON.stringify(buyingList)
                      )}`}
                      download={
                        fileName.trim() === ""
                          ? "اسهمي - " +
                            new Date().getTime().toString() +
                            ".json"
                          : fileName + ".json"
                      }
                      className="btn btn-primary mt-2 mb-2 w-25 "
                    >
                      حفظ
                    </a>
                  </div>
                </div>
                <hr className="mt-3 mb-3"></hr>
                <label htmlFor="inputEmail4" className="text-dark">
                  رفع البيانات
                </label>
                <div className="custom-file" id="customFile">
                  <input
                    type="file"
                    className="custom-file-input float-left"
                    id="exampleInputFile"
                    ref={fileInput}
                    accept="application/JSON"
                    onChange={handleChange}
                  ></input>
                  <label
                    className="custom-file-label"
                    data-browse="استعرض"
                    id="uplaodFileInput"
                  >
                    اختر ملف
                  </label>
                  <small className="form-text text-danger">
                    تأكد من حفظ البيانات الحالية قبل رفع بيانات جديدة فسوف يتم
                    استبدالها بالبيانات الجديدة
                  </small>
                  <button
                    className="btn btn-primary p-1 mt-2 mb-2 w-25"
                    onClick={updateLists}
                  >
                    رفع
                  </button>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
